import {styled} from "@mui/material/styles";
import {Box, Grid, Typography} from "@mui/material";

export const DesignGridContainer = styled(Grid)(({theme}) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    height: '32px',
    cursor: 'pointer',
    '&::-webkit-scrollbar': {
        display: 'none'
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    backgroundColor: 'transparent', // No background on the container
    padding: '0', // No padding needed
}));

export const DesignOptionWrapper = styled(Box)(({theme}) => ({
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '0',
    gap: '5px', // Space between the buttons
}));

export const DesignOption = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({theme, isActive}) => ({
    textDecoration: 'none',
    height: '100%',
    width: '100px',
    color: isActive ? 'white' : 'white',
    fontSize: '16px',
    fontWeight: 600,
    alignContent: 'center',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '30px', // More rounded corners
    transition: 'all 0.2s ease-in-out',
    backgroundColor: isActive ? theme.palette.primary.main : 'transparent', // Light blue for active "Post"
    border: isActive ? 'none' : '1px solid #ffffff',
    textTransform: 'capitalize',
    '&:hover': {
        opacity: 0.9,
        backgroundColor: theme.palette.primary.main
    }
}));